import { render } from "./DeliveryImporter.vue?vue&type=template&id=410308c0"
import script from "./DeliveryImporter.vue?vue&type=script&lang=js"
export * from "./DeliveryImporter.vue?vue&type=script&lang=js"

import "./DeliveryImporter.vue?vue&type=style&index=0&id=410308c0&lang=css"
script.render = render

export default script